module.exports = __webpack_public_path__ + "static/olivetree-logo.1ae80eb1.svg";